import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
  onClick?: () => void;
}
export function Card({
  children,
  className = '',
  hoverEffect = false,
  onClick
}: CardProps) {
  return <motion.div className={`bg-white rounded-2xl border border-slate-200 overflow-hidden ${className}`} whileHover={hoverEffect ? {
    y: -4,
    boxShadow: '0 10px 30px -10px rgba(0,0,0,0.1)'
  } : undefined} transition={{
    duration: 0.2
  }} onClick={onClick} data-id="element-424">
      {children}
    </motion.div>;
}